<div class="activity-bg-section">
    <div class="activity-section">
        <div class="activity-heading-section">
            <span>Activity Details</span>
            <div>
                <ng-container *ngIf="!isReadOnly">
                    <ng-container *ngIf="activity_data.id != null">
                        <div class="each-activity-header-action-section">
                            <!-- <img src="assets/delete-activity.png" class="activity-header-action-icon" [matTooltip]="'Delete Activity'" (click)="removeActivity(activity_data)" /> -->
                            
                            <!-- Remove Delete <img src="assets/activity-delete.png" class="activity-header-action-icon" [matTooltip]="'Delete Activity'" (click)="removeActivity(activity_data)" /> -->
                        </div>
                        <ng-container *ngIf="activity_data.status != 3">
                            <div class="each-activity-header-action-section" *ngIf="!activity_data.activity_paused">
                                <!-- <img src="assets/stop-activity.png" class="activity-header-action-icon" [matTooltip]="'Stop Activity'" (click)="openAutomatedActivityOperationModal()" /> -->
                                <img src="assets/activity-stop.png" class="activity-header-action-icon" [matTooltip]="'Stop Activity'" (click)="openAutomatedActivityOperationModal()" />
                            </div>
                            <div class="each-activity-header-action-section" *ngIf="activity_data.activity_paused">
                                <!-- <img src="assets/resume-activity.png" class="activity-header-action-icon" [matTooltip]="'Resume Activity'" (click)="openAutomatedActivityOperationModal()" /> -->
                                <!-- <img src="assets/record-history.png" class="activity-header-action-icon" [matTooltip]="'Resume Activity'" (click)="openAutomatedActivityOperationModal()" /> -->
                                <img src="assets/activity-reume.png" class="activity-header-action-icon" [matTooltip]="'Resume Activity'" (click)="openAutomatedActivityOperationModal()" />
                            </div>
                        </ng-container>
                        <!-- <div class="each-activity-header-action-section" *ngIf="activity_data.communication_type_name == 'Email'">
                            <img src="assets/send-email.png" class="activity-header-action-icon" [matTooltip]="'Send Email'" (click)="openEmail(data)" />
                            <img src="assets/email-active.png" class="activity-header-action-icon" [matTooltip]="'Send Email'" (click)="openEmail(activity_data)" />
                            <img src="assets/activity-send-email.png" class="activity-header-action-icon" [matTooltip]="'Send Email'" (click)="openEmail(activity_data)" />
                        </div> -->
                    </ng-container>
                    <!-- <div class="each-activity-header-action-section" *ngIf="((activity_data.activity_type == 1) || (activity_data.activity_type == 4) || (activity_data.activity_type == 5))"> -->
                    <div class="each-activity-header-action-section" *ngIf="activity_data.email_template != null && user_role != 'Advisor Manager'">
                        <!-- <img src="assets/view-email.png" class="activity-header-action-icon" [matTooltip]="'View Email'" (click)="openActivityEmailPreviewModal(data)" /> -->
                        <!-- <img src="assets/view-record.png" class="activity-header-action-icon" [matTooltip]="'View Email'" (click)="openActivityEmailPreviewModal(activity_data)" /> -->
                        <img src="assets/activity-view-email.png" class="activity-header-action-icon" [matTooltip]="'View Email'" (click)="openActivityEmailPreviewModal(activity_data)" />
                    </div>
                </ng-container>
                <div class="each-activity-header-action-section">
                    <span class="activity-close-icon" (click)="close()">&times;</span>
                </div>
            </div>
        </div>
        <div class="activity-content-section">
            <ng-container *ngIf="activity_data_loaded">
                <div class="activity-details-section">
                    <div class="activity-fields-section">
                        <div class="activity-breadcrumb-section" *ngIf="activity_data.id != null">
                            <ng-container *ngIf="activity_data.task_type == 'Main Task'">
                                <span class="activity-breadcrumb-text" *ngIf="user_role != 'Advisor Manager'">{{activity_data.client_name}}</span>
                                <span class="activity-breadcrumb-text" *ngIf="user_role == 'Advisor Manager'">{{activity_data.advisor_name}}</span>
                                <span class="activity-breadcrumb-text">
                                    <img src="assets/sub_tasks_open.png" />
                                </span>
                                <span class="activity-breadcrumb-text">{{activity_data.name}}</span>
                            </ng-container>
                            <ng-container *ngIf="activity_data.task_type != 'Main Task'">
                                <span class="activity-breadcrumb-text" *ngIf="user_role != 'Advisor Manager'">{{activity_data.client_name}}</span>
                                <span class="activity-breadcrumb-text" *ngIf="user_role == 'Advisor Manager'">{{activity_data.advisor_name}}</span>
                                <span class="activity-breadcrumb-text">
                                    <img src="assets/sub_tasks_open.png" />
                                </span>
                                <!-- <span class="activity-breadcrumb-text activity-breadcrumb-active" (click)="selectSubTask(activity_data.parent_activity_details)">{{activity_data.parent_activity_details.name}}</span> -->
                                <span class="activity-breadcrumb-text">{{activity_data.parent_activity_details.name}}</span>
                                <span class="activity-breadcrumb-text">
                                    <img src="assets/sub_tasks_open.png" />
                                </span>
                                <span class="activity-breadcrumb-text">{{activity_data.name}}</span>
                            </ng-container>
                        </div>
                        <div class="activity-name-section">
                            <p class="each-activity-details-heading">Activity Name</p>
                            <ng-container *ngIf="!show_activity_name_options && activity_data.id != null">
                                <span class="activity-name" *ngIf="activity_data.name != '' && activity_data.name != null" [ngClass]="{'input-error-bg': activity_name_error}">{{activity_data.name}}</span>
                                <span class="activity-name" *ngIf="activity_data.name == '' || activity_data.name == null" [ngClass]="{'input-error-bg': activity_name_error}">Untitled Activity</span>
                                <img src="assets/activity-edit.png" class="activity-edit-icon" *ngIf="!isReadOnly" (click)="activityNameFocus()" />
                            </ng-container>
                            <ng-container *ngIf="show_activity_name_options || activity_data.id == null">
                                <div class="activity-editable-input-section">
                                    <input type="text" class="activity-editable-input" [(ngModel)]="activity_data.name" [ngClass]="{'input-error-bg': activity_name_error}" />
                                </div>
                                <div class="activity-editable-action-section"  *ngIf="activity_data.id != null">
                                    <img src="assets/activity-save.png" class="activity-editable-action-icon" (click)="saveActivityName()" />
                                    <img src="assets/activity-cancel.png" class="activity-editable-action-icon" (click)="activityNameBlur()" />
                                </div>
                            </ng-container>
                            <p class="input-error" *ngIf="activity_name_error">Activity name is required.</p>
                        </div>

                        

                        <div class="each-activity-details-section">
                            <p class="each-activity-details-heading" *ngIf="activity_data.id == null">Description</p>
                            <div class="each-activity-details-heading-section" *ngIf="activity_data.id != null">
                                <div>
                                    <span class="each-activity-details-heading">Description</span>
                                    <ng-container>
                                        <img src="assets/activity-edit.png" class="activity-edit-icon" *ngIf="!isReadOnly" (click)="focusDescriptionSection()" />
                                    </ng-container>
                                </div>
                            </div>
                            <ng-container *ngIf="!show_description_section && activity_data.id != null">
                                <ng-container *ngIf="activity_data.description != '' && activity_data.description != null">
                                    <p class="activity-description" [innerHTML]="activity_data.description"></p>
                                </ng-container>
                                <ng-container *ngIf="activity_data.description == '' || activity_data.description == null">
                                    <p class="activity-description">-</p>
                                </ng-container>
                            </ng-container>
                            <ng-container *ngIf="show_description_section || activity_data.id == null">
                                <div class="activity-editable-input-section">
                                    <app-textarea-tagging [value]="activity_data.description" [users]="tagging_users_list" [placeholder]="'Description ...'" (valueChanged)="activity_data.description = $event"></app-textarea-tagging>
                                </div>
                                <div class="activity-editable-action-section"  *ngIf="activity_data.id != null">
                                    <img src="assets/activity-save.png" class="activity-editable-action-icon" (click)="saveActivityDescription()" />
                                    <img src="assets/activity-cancel.png" class="activity-editable-action-icon" (click)="blurDescriptionSection()" />
                                </div>
                            </ng-container>
                        </div>

                        <div class="activity-more-actions-section" *ngIf="activity_data.id != null">
                            <div>
                                <!-- <button class="activity-more-action" (click)="showAttachmentsView()">
                                    <img src="assets/activity-attachment.png" class="activity-more-action-icon" />
                                    <span>Attachments</span>
                                </button>

                                <ng-container *ngIf="((user_role == 'Advisor') || (user_role == 'Relationship Manager') || (user_role == 'AFA' && (activity_data.afa_name == '' || activity_data.afa_name == null || activity_data.afa_name == 'Self'))) && (activity_data.activity_type == 1 || activity_data.activity_type == 2)">
                                    <button class="activity-more-action" (click)="showCloseDealView()">
                                        <img src="assets/activity-deal.png" class="activity-more-action-icon" />
                                        <span>Close Deal</span>
                                    </button>
                                </ng-container>

                                <ng-container *ngIf="((user_role == 'Advisor') || (user_role == 'Relationship Manager') || (user_role == 'AFA' && (activity_data.afa_name == '' || activity_data.afa_name == null || activity_data.afa_name == 'Self'))) && (activity_data.activity_type == 3 || activity_data.activity_type == 5)">
                                    <button class="activity-more-action" (click)="showChangeOutcomeView()">
                                        <img src="assets/activity-deal.png" class="activity-more-action-icon" />
                                        <span>Change Outcome</span>
                                    </button>
                                </ng-container> -->
                            </div>

                            <div>
                                <ng-container *ngIf="activity_data.capture_response.captured_response == false">
                                    <button class="capture-response-action" (click)="showCaptureResponse()">Capture Response</button>
                                </ng-container>
                            </div>
                        </div>

                        <ng-container *ngIf="activity_data.id != null">
                            <ng-container *ngIf="activity_data.capture_response.captured_response == true || show_capture_response_section">
                                <div id="capture-response-view">
                                    <div class="each-activity-details-section" >
                                        <div class="each-activity-details-heading-section">
                                            <div>
                                                <span class="each-activity-details-heading">Response</span>
                                                <img src="assets/activity-edit.png" class="activity-edit-icon" *ngIf="!isReadOnly && !show_capture_response_section" (click)="showCaptureResponse()" />
                                            </div>
                                        </div>
                                        <ng-container *ngIf="!show_capture_response_section">
                                            <div class="capture-response-details-section">
                                                <div>
                                                    <span class="capture-response-date">{{activity_data.capture_response.response_capture_date | date: 'dd MMM yyyy'}}</span>
                                                </div>
                                                <div>
                                                    <div class="capture-response-channel-section">
                                                        <img [src]="activity_data.capture_response.image_link" class="capture-response-channel-image" />
                                                        <span>{{activity_data.capture_response.response_channel_name}}</span>
                                                    </div>
                                                    <div class="capture-response-channel-section">
                                                        <span class="activity-table-tag completed-status-tag" *ngIf="activity_data.capture_response.response_status  ==  'Interested'">Interested</span>
                                                        <span class="activity-table-tag cancelled-status-tag" *ngIf="activity_data.capture_response.response_status  ==  'Not Interested'">Not Interested</span>
                                                        <!-- <span class="activity-table-tag pending-status-tag" *ngIf="activity_data.capture_response.response_status  ==  'No Contact'">No Contact</span> -->
                                                        <span class="activity-table-tag pending-status-tag" *ngIf="activity_data.capture_response.response_status  ==  'No Response'">No Response</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="capture-response-comments-section">
                                                <span [innerHTML]="activity_data.capture_response.response_comments"></span>
                                            </div>
                                        </ng-container>

                                        <ng-container *ngIf="show_capture_response_section">
                                            <div class="capture-response-input-section">
                                                <p class="capture-response-input-label">Response Status</p>
                                                <mat-select class="capture-response-input" [(ngModel)]="activity_data.capture_response.response_status">
                                                    <mat-option [value]="''">Select Response Status</mat-option>
                                                    <mat-option [value]="'Interested'">Interested</mat-option>
                                                    <mat-option [value]="'Not Interested'">Not Interested</mat-option>
                                                    <!-- <mat-option [value]="'No Contact'">No Contact</mat-option> -->
                                                    <mat-option [value]="'No Response'">No Response</mat-option>
                                                </mat-select>
                                                <p class="input-error" *ngIf="capture_response_data_errors.response_status">Response Status is Required.</p>
                                            </div>
                                            <div class="capture-response-input-section">
                                                <p class="capture-response-input-label">Response Channel</p>
                                                <mat-select class="capture-response-input" [(ngModel)]="activity_data.capture_response.response_channel">
                                                    <mat-option [value]="''">Select Response Channel</mat-option>
                                                    <mat-option *ngFor="let communication_type of communication_type_list" [value]="communication_type.id">{{communication_type.name}}</mat-option>
                                                </mat-select>
                                                <p class="input-error" *ngIf="capture_response_data_errors.response_channel">Response Channel is Required.</p>
                                            </div>
                                            <div class="capture-response-input-section">
                                                <p class="capture-response-input-label">Response Date</p>
                                                <input
                                                    type="text"
                                                    class="capture-response-input"
                                                    bsDatepicker
                                                    placement="left"
                                                    [(ngModel)]="activity_data.capture_response.response_capture_date"
                                                    [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
                                                />
                                                <p class="input-error" *ngIf="capture_response_data_errors.response_capture_date">Response Date is Required.</p>
                                            </div>
                                            <div>
                                                <div class="capture-response-input-section" style="width: 100%;">
                                                    <p class="capture-response-input-label">Response Comments</p>
                                                    <app-textarea-tagging [value]="activity_data.capture_response.response_comments" [users]="tagging_users_list" [placeholder]="'Response Comments  ...'" (valueChanged)="activity_data.capture_response.response_comments = $event"></app-textarea-tagging>
                                                    <p class="input-error" *ngIf="capture_response_data_errors.response_comments">Response Comments is Required.</p>
                                                </div>
                                            </div>
                                            <div class="each-activity-details-action-section">
                                                <button class="page-modal-primary-button" (click)="saveCaptureResponse()">Save</button>
                                                <button class="page-modal-secondary-button" (click)="hideCaptureResponse()">Cancel</button>
                                            </div>
                                        </ng-container>
                                    </div>
                                </div>
                            </ng-container>
                        </ng-container>

                        <ng-container *ngIf="activity_data.id != null">
                            <div id="attachments-view">
                                <div class="each-activity-details-section" *ngIf="show_attachments_view" >
                                    <div class="each-activity-details-heading-section">
                                        <div>
                                            <span class="each-activity-details-heading">Attachments</span>
                                        </div>
                                        <div>
                                            <span class="each-activity-details-close-icon" (click)="hideAttachmentsView()">&times;</span>
                                        </div>
                                    </div>
                                    <ng-container>
                                        <table class="attachments-table">
                                            <thead>
                                                <tr>
                                                    <th *ngIf="!isReadOnly">Actions</th>
                                                    <th>Attachment Name</th>
                                                    <th>Comments</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <ng-container *ngFor="let attachment of activity_data.attachments; let attachmentIndex = index;">
                                                    <tr *ngIf="attachment_operation_index != attachmentIndex">
                                                        <td *ngIf="!isReadOnly">
                                                            <img src="assets/attachment-edit.png" [matTooltip]="'Upload Atttachmentt'" class="each-attachment-icon" (click)="openAttachmentOperation(attachment, 'Edit', attachmentIndex)" />
                                                            <img src="assets/attachment-download.png" [matTooltip]="'Download Atttachmentt'" class="each-attachment-icon" (click)="downloadAttachment(attachment)" />
                                                            <!-- Remove Delete <img src="assets/attachment-delete.png" [matTooltip]="'Delete Atttachmentt'" class="each-attachment-icon" (click)="removeAttachment(attachment, attachmentIndex)" /> -->
                                                        </td>
                                                        <td>
                                                            <p>{{attachment.attachment_filename}}</p>
                                                        </td>
                                                        <td>
                                                            <p [innerHTML]="attachment.comments"></p>
                                                        </td>
                                                    </tr>
                                                    <tr *ngIf="attachment_operation_index == attachmentIndex">
                                                        <td colspan="3">
                                                            <ng-container *ngTemplateOutlet="attachmentsFieldsSection;"></ng-container>
                                                        </td>
                                                    </tr>
                                                </ng-container>
                                            </tbody>
                                        </table>
                                    </ng-container>
                                    <ng-container *ngIf="attachment_operation_index == null">
                                        <ng-container *ngTemplateOutlet="attachmentsFieldsSection;"></ng-container>
                                    </ng-container>
                                    <div class="each-activity-details-button-section" *ngIf="attachment_operation_index != null && !isReadOnly">
                                        <button class="activity-more-action" (click)="openAttachmentOperation(attachment_data, 'Add', null)" style="margin-right: 0;">+ Add New Attachment</button>
                                    </div>
                                </div>
                                
                            </div>





                            <div id="close-deal-view">
                                <div class="each-activity-details-section" *ngIf="show_close_deal_view" >
                                    <div class="each-activity-details-heading-section">
                                        <div>
                                            <span class="each-activity-details-heading">Close Deal</span>
                                        </div>
                                        <div>
                                            <span class="each-activity-details-close-icon" (click)="hideCloseDealView()">&times;</span>
                                        </div>
                                    </div>
                                    <ng-container>
                                        <ng-container *ngTemplateOutlet="productConversionSection;"></ng-container>
                                        <div class="each-activity-details-action-section">
                                            <button class="page-modal-primary-button" (click)="addProduct()">Save</button>
                                            <!-- <button class="page-modal-secondary-button" (click)="resetCloseDealData()">Cancel</button> -->
                                            <button class="page-modal-secondary-button" (click)="hideCloseDealView()">Cancel</button>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>





                            <div id="change-outcome-view">
                                <div class="each-activity-details-section" *ngIf="show_change_outcome_view" >
                                    <div class="each-activity-details-heading-section">
                                        <div>
                                            <span class="each-activity-details-heading">Change Outcome</span>
                                        </div>
                                        <div>
                                            <span class="each-activity-details-close-icon" (click)="hideChangeOutcomeView()">&times;</span>
                                        </div>
                                    </div>
                                    <ng-container>
                                        <ng-container *ngTemplateOutlet="outcomeConversionSection;"></ng-container>
                                        <div class="each-activity-details-action-section">
                                            <button class="page-modal-primary-button" (click)="addOutcome()">Save</button>
                                            <!-- <button class="page-modal-secondary-button" (click)="resetCloseDealData()">Cancel</button> -->
                                            <button class="page-modal-secondary-button" (click)="hideChangeOutcomeView()">Cancel</button>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="activity_data.id != null">
                            <ng-container *ngIf="activity_data.task_type == 'Main Task'">
                                <div class="each-activity-details-section">
                                    <div class="each-activity-details-heading-section">
                                        <div>
                                            <span class="each-activity-details-heading">Sub Tasks</span>
                                        </div>
                                    </div>
                                    <ng-cotainer *ngIf="sub_tasks_data_loaded">
                                        <table class="activity-inner-table">
                                            <thead>
                                                <tr>
                                                    <th>Activity Name</th>
                                                    <th>Status</th>
                                                    <!-- <th>Activity Type</th> -->
                                                    <th>Scheduled Date</th>
                                                    <th>Response</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let sub_task of sub_tasks_data">
                                                    <td>
                                                        <p class="sub-activity-name automated-sub-activity-name" (click)="selectSubTask(sub_task)">{{sub_task.name}}</p>
                                                    </td>
                                                    <td>
                                                        <!-- <span class="activity-table-tag" [ngClass]="{'pending-status-tag': sub_task.status_name == 'Pending', 'completed-status-tag': sub_task.status_name == 'Completed', 'in-progress-status-tag': sub_task.status_name == 'In Progress', 'not-required-status-tag': sub_task.status_name == 'Not Required', 'cancelled-status-tag': sub_task.status_name == 'Cancelled'}">{{sub_task.status_name}}</span> -->
                                                        <span class="activity-table-tag" [ngClass]="{'pending-status-tag': sub_task.status_name == 'Pending', 'completed-status-tag': sub_task.status_name == 'Completed', 'in-progress-status-tag': sub_task.status_name == 'In Progress', 'not-required-status-tag': sub_task.status_name == 'Not Required', 'cancelled-status-tag': sub_task.status_name == 'Cancelled', 'manual-task-tag': sub_task.status_name == 'Unsubscribed', 'medium-importance-tag': sub_task.status_name == 'Not Started'}">{{sub_task.status_name}}</span>
                                                    </td>
                                                    <!-- <td>
                                                        <span *ngIf="(sub_task.activity_type != 1) && (sub_task.activity_type != 4) && (sub_task.activity_type != 5)" class="activity-table-tag manual-task-tag">Manual</span>
                                                        <span *ngIf="(sub_task.activity_type == 1) || (sub_task.activity_type == 4) || (sub_task.activity_type == 5)"class="activity-table-tag automated-task-tag">Automated</span>
                                                    </td> -->
                                                    <td>{{sub_task.scheduled_date | date: "dd MMM yyyy"}}</td>
                                                    <td>
                                                        <span [innerHTML]="sub_task.capture_response.response_comments"></span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <ng-container *ngIf="!isReadOnly">
                                            <div class="each-activity-details-button-section" *ngIf="!show_add_sub_task_view">
                                                <!-- <button class="activity-more-action" (click)="addSubTask()" style="margin-right: 0;">+ Add New Sub Task</button> -->
                                                <button class="activity-more-action" (click)="addManualSubTask()" style="margin-right: 0;">+ Add New Sub Task</button>
                                            </div>

                                            <div *ngIf="show_add_sub_task_view">
                                                <div class="activity-editable-input-section">
                                                    <input type="text" class="add-activity-input" [(ngModel)]="sub_task_name" />
                                                </div>
                                                <div class="activity-editable-action-section" *ngIf="!save_sub_task_loader">
                                                    <img src="assets/activity-save.png" class="activity-editable-action-icon" (click)="saveSubTask()" />
                                                    <img src="assets/activity-cancel.png" class="activity-editable-action-icon" (click)="cancelSubTask()" />
                                                </div>
                                                <div class="activity-editable-action-section" *ngIf="save_sub_task_loader">
                                                    <img src="assets/activity-save.png" class="activity-editable-action-icon" />
                                                    <img src="assets/activity-cancel.png" class="activity-editable-action-icon" />
                                                </div>
                                            </div>
                                        </ng-container>
                                    </ng-cotainer>
                                    <ng-cotainer *ngIf="!sub_tasks_data_loaded">
                                        <app-loader [loading_text]="'Loading Sub Tasks'"></app-loader>
                                    </ng-cotainer>
                                </div>
                            </ng-container>
                        </ng-container>

                        <!-- <div class="each-activity-details-section" #attachmentssView *ngIf="show_attachments_view" >
                            <div class="each-activity-details-heading-section">
                                <div>
                                    <span class="each-activity-details-heading">Attachments</span>
                                </div>
                                <div>
                                    <span class="each-activity-details-close-icon" (click)="hideAttachmentsView()">&times;</span>
                                </div>
                            </div>
                        </div> -->


                        <!-- <div class="activity-name-input-section">
                            <p class="activity-name-input-label">Activity Name</p>
                            <input type="text" class="activity-name-input" [(ngModel)]="activity_data.name" (focus)="activityNameFocus()" [readonly]="isReadOnly" />
                            <div class="activity-name-input-action-section" *ngIf="!isReadOnly && show_activity_name_options">
                                <img src="assets/ic-circle-tick.png" class="activity-name-input-action" (click)="saveActivityName()" />
                                <img src="assets/ic-circle-cross.png" class="activity-name-input-action" (click)="activityNameBlur()" />
                            </div>
                        </div> -->

                        <!-- <div class="activity-name-input-section">
                            <p class="activity-name-input-label">Description</p>
                            <ng-container *ngIf="!show_description_section">
                                <p class="activity-description-text" [innerHTML]="activity_data.description" *ngIf="activity_data.description != '' && activity_data.description != null" (click)="focusDescriptionSection()"></p>
                                <p class="activity-description-text" *ngIf="activity_data.description == '' || activity_data.description == null" (click)="focusDescriptionSection()">Add Descripton here....</p>
                            </ng-container>
                            <div class="" *ngIf="!isReadOnly && show_description_section">
                                <app-textarea-tagging [value]="activity_data.description" [users]="tagging_users_list" [placeholder]="'Description ...'" (valueChanged)="activity_data.description = $event"></app-textarea-tagging>
                                <div class="page-modal-footer-section">
                                    <button class="page-modal-primary-button" (click)="saveActivityDescription()">Save</button>
                                    <button class="page-modal-secondary-button" (click)="blurDescriptionSection()">Cancel</button>
                                </div>
                            </div>
                        </div> -->

                        <!-- <div class="activity-name-input-section">
                            <p class="activity-name-input-label">Capture Response</p>
                            <ng-container *ngIf="!show_capture_response_section">
                                <div *ngIf="activity_data.capture_response.captured_response == true" (click)="showCaptureResponse()">
                                    <p class="activity-description-text">Captured Response on <strong>{{activity_data.capture_response.response_capture_date | date: 'dd MMM yyyy'}}</strong> as <strong>{{activity_data.capture_response.response_status}}</strong> through communication channel <strong>{{activity_data.capture_response.response_channel_name}}</strong></p>
                                    <p class="activity-description-text" *ngIf="activity_data.capture_response.response_comments != '' && activity_data.capture_response.response_comments != null"> 
                                       <strong>Response Comments:</strong>  <span [innerHTML]="activity_data.capture_response.response_comments"></span>
                                    </p>
                                </div>
                                <p class="activity-description-text" *ngIf="activity_data.capture_response.captured_response == false" (click)="showCaptureResponse()">Capture Response here....</p>
                            </ng-container>
                            <div class="" *ngIf="!isReadOnly && show_capture_response_section">
                                <div class="capture-response-input-section">
                                    <p class="capture-response-input-label">Response Status</p>
                                    <mat-select class="capture-response-input" [(ngModel)]="activity_data.capture_response.response_status">
                                        <mat-option [value]="''">Select Response Status</mat-option>
                                        <mat-option [value]="'Interested'">Interested</mat-option>
                                        <mat-option [value]="'Not Interested'">Not Interested</mat-option>
                                        <mat-option [value]="'No Contact'">No Contact</mat-option>
                                    </mat-select>
                                    <p class="input-error" *ngIf="capture_response_data_errors.response_status">Response Status is Required.</p>
                                </div>
                                <div class="capture-response-input-section">
                                    <p class="capture-response-input-label">Response Channel</p>
                                    <mat-select class="capture-response-input" [(ngModel)]="activity_data.capture_response.response_channel">
                                        <mat-option [value]="''">Select Response Channel</mat-option>
                                        <mat-option *ngFor="let communication_type of communication_type_list" [value]="communication_type.id">{{communication_type.name}}</mat-option>
                                    </mat-select>
                                    <p class="input-error" *ngIf="capture_response_data_errors.response_channel">Response Channel is Required.</p>
                                </div>
                                <div class="capture-response-input-section">
                                    <p class="capture-response-input-label">Response Date</p>
                                    <input
                                        type="text"
                                        class="capture-response-input"
                                        bsDatepicker
                                        placement="left"
                                        [(ngModel)]="activity_data.capture_response.response_capture_date"
                                        [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
                                    />
                                    <p class="input-error" *ngIf="capture_response_data_errors.response_capture_date">Response Date is Required.</p>
                                </div>
                                <div>
                                    <div class="capture-response-input-section" style="width: 100%;">
                                        <p class="capture-response-input-label">Response Comments</p>
                                        <app-textarea-tagging [value]="activity_data.capture_response.response_comments" [users]="tagging_users_list" [placeholder]="'Response Comments ...'" (valueChanged)="activity_data.capture_response.response_comments = $event"></app-textarea-tagging>
                                        <p class="input-error" *ngIf="capture_response_data_errors.response_comments">Response Comments is Required.</p>
                                    </div>
                                </div>
                                <div class="page-modal-footer-section">
                                    <button class="page-modal-primary-button" (click)="saveCaptureResponse()">Save</button>
                                    <button class="page-modal-secondary-button" (click)="hideCaptureResponse()">Cancel</button>
                                </div>
                            </div>
                        </div> -->
                        
                        <!-- <div class="activity-name-input-section" *ngIf="activity_data.task_type == 'Main Task'">
                            <p class="activity-name-input-label">Sub Tasks</p>
                            <ng-cotainer *ngIf="sub_tasks_data_loaded">
                                <table class="activity-inner-table">
                                    <thead>
                                        <tr>
                                            <th>Activity Name</th>
                                            <th>Status</th>
                                            <th>Activity Type</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let sub_task of sub_tasks_data">
                                            <td>
                                                <p class="sub-activity-name automated-sub-activity-name" (click)="selectSubTask(sub_task)">{{sub_task.name}}</p>
                                            </td>
                                            <td>
                                                <span class="activity-table-tag" [ngClass]="{'pending-status-tag': sub_task.status_name == 'Pending', 'completed-status-tag': sub_task.status_name == 'Completed', 'in-progress-status-tag': sub_task.status_name == 'In Progress', 'not-required-status-tag': sub_task.status_name == 'Not Required', 'cancelled-status-tag': sub_task.status_name == 'Cancelled'}">{{sub_task.status_name}}</span>
                                            </td>
                                            <td>
                                                <span *ngIf="(sub_task.activity_type != 1) && (sub_task.activity_type != 4) && (sub_task.activity_type != 5)" class="activity-table-tag manual-task-tag">Manual</span>
                                                <span *ngIf="(sub_task.activity_type == 1) || (sub_task.activity_type == 4) || (sub_task.activity_type == 5)"class="activity-table-tag automated-task-tag">Automated</span>
                                            </td>
                                        </tr>
                                        <tr class="sub-tasks-row" *ngIf="!isReadOnly">
                                            <td colspan="3">
                                                <button class="add-activity-action-primary" *ngIf="!show_add_sub_task_view" (click)="addSubTask()">Add Sub Task</button>
                
                                                <div class="add-activity-section" *ngIf="show_add_sub_task_view">
                                                    <div class="add-activity-input-section">
                                                        <input type="text" class="add-activity-input" [(ngModel)]="sub_task_name" />
                                                    </div>
                                                    <div class="add-activity-action-section">
                                                        <button class="add-activity-action-primary" (click)="saveSubTask()">Create</button>
                                                        <button class="add-activity-action-secondary" (click)="cancelSubTask()">Cancel</button>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </ng-cotainer>
                            <ng-cotainer *ngIf="!sub_tasks_data_loaded">
                                <app-loader [loading_text]="'Loading Sub Tasks'"></app-loader>
                            </ng-cotainer>
                        </div> -->
                        <div class="each-activity-details-section" *ngIf="activity_data.id != null">
                            <div class="each-activity-details-heading-section">
                                <div>
                                    <span class="each-activity-details-heading">Activity</span>
                                </div>
                            </div>
                            <div class="activity-info-tabs-section">
                                <span class="show-activity-text">Show:</span>
                                <div class="each-activity-info-tab" [ngClass]="{'each-activity-tab-selcted': activity_tab_selected == 'Comments'}" (click)="activity_tab_selected = 'Comments'">
                                    <span>
                                        Comments
                                        <span *ngIf="activity_data.comments.length > 0">({{activity_data.comments.length}})</span>
                                    </span>
                                </div>
                                <div class="each-activity-info-tab" [ngClass]="{'each-activity-tab-selcted': activity_tab_selected == 'Attachments'}" (click)="activity_tab_selected = 'Attachments'">
                                    <span>
                                        Attachments
                                        <span *ngIf="activity_data.attachments.length > 0">({{activity_data.attachments.length}})</span>
                                    </span>
                                </div>
                                <ng-container *ngIf="((user_role == 'Advisor') || (user_role == 'Relationship Manager') || (user_role == 'AFA' && (activity_data.afa_name == '' || activity_data.afa_name == null || activity_data.afa_name == 'Self'))) && (activity_data.activity_type == 1 || activity_data.activity_type == 2)">
                                    <div class="each-activity-info-tab" [ngClass]="{'each-activity-tab-selcted': activity_tab_selected == 'Close Deal'}" (click)="activity_tab_selected = 'Close Deal'">
                                        <span>Close Deal</span>
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="((user_role == 'Advisor') || (user_role == 'Relationship Manager') || (user_role == 'AFA' && (activity_data.afa_name == '' || activity_data.afa_name == null || activity_data.afa_name == 'Self'))) && (activity_data.activity_type == 3 || activity_data.activity_type == 5)">
                                    <div class="each-activity-info-tab" [ngClass]="{'each-activity-tab-selcted': activity_tab_selected == 'Change Outcome'}" (click)="activity_tab_selected = 'Change Outcome'">
                                        <span>Change Outcome</span>
                                    </div>
                                </ng-container>
                                <div class="each-activity-info-tab" [ngClass]="{'each-activity-tab-selcted': activity_tab_selected == 'History'}" (click)="activity_tab_selected = 'History'">
                                    <span>
                                        History
                                        <span *ngIf="activity_data.past_activities.length > 0">({{activity_data.past_activities.length}})</span>
                                    </span>
                                </div>
                                <ng-container *ngIf="user_role != 'Advisor Manager'">
                                    <div class="each-activity-info-tab" [ngClass]="{'each-activity-tab-selcted': activity_tab_selected == 'Campaign History'}" (click)="activity_tab_selected = 'Campaign History'">
                                        <span>
                                            Campaign History
                                            <span *ngIf="activity_data.campaign_history.length > 0">({{activity_data.campaign_history.length}})</span>
                                        </span>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                        
                        <!-- <div class="activity-info-tabs-section">
                            <span>Show:</span>
                            <div class="each-activity-info-tab" [ngClass]="{'each-activity-tab-selcted': activity_tab_selected == 'Comments'}" (click)="activity_tab_selected = 'Comments'">
                                <span>Comments</span>
                            </div>
                            <div class="each-activity-info-tab" [ngClass]="{'each-activity-tab-selcted': activity_tab_selected == 'Attachments'}" (click)="activity_tab_selected = 'Attachments'">
                                <span>Attachments</span>
                            </div>
                            <ng-container *ngIf="((user_role == 'Advisor') || (user_role == 'Relationship Manager') || (user_role == 'AFA' && (activity_data.afa_name == '' || activity_data.afa_name == null || activity_data.afa_name == 'Self'))) && (activity_data.activity_type == 1 || activity_data.activity_type == 2)">
                                <div class="each-activity-info-tab" [ngClass]="{'each-activity-tab-selcted': activity_tab_selected == 'Close Deal'}" (click)="activity_tab_selected = 'Close Deal'">
                                    <span>Close Deal</span>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="((user_role == 'Advisor') || (user_role == 'Relationship Manager') || (user_role == 'AFA' && (activity_data.afa_name == '' || activity_data.afa_name == null || activity_data.afa_name == 'Self'))) && (activity_data.activity_type == 3 || activity_data.activity_type == 5)">
                                <div class="each-activity-info-tab" [ngClass]="{'each-activity-tab-selcted': activity_tab_selected == 'Change Outcome'}" (click)="activity_tab_selected = 'Change Outcome'">
                                    <span>Change Outcome</span>
                                </div>
                            </ng-container>
                            <div class="each-activity-info-tab" [ngClass]="{'each-activity-tab-selcted': activity_tab_selected == 'History'}" (click)="activity_tab_selected = 'History'">
                                <span>History</span>
                            </div>
                        </div> -->

                        <ng-container *ngIf="activity_data.id != null">
                            <ng-container *ngIf="activity_tab_selected == 'Comments'">

                                <ng-container *ngIf="show_comments_operation_section == null && !isReadOnly">
                                    <ng-container *ngTemplateOutlet="commentsFieldsSection;"></ng-container>
                                </ng-container>

                                <ng-container *ngFor="let comment of activity_data.comments; let commentIndex = index">
                                    <div class="each-comment-section" *ngIf="show_comments_operation_section != commentIndex">
                                        <div class="comment-details-section">
                                            <div class="comment-author-circle">
                                                <span>{{comment.commented_by_name[0]}}</span>
                                            </div>
                                            <div>
                                                <span class="comment-author-name">{{comment.commented_by_name}}</span>
                                                <span class="comment-date">{{comment.comment_date | date: "MMM d, y, h:mm:ss a"}}</span>
                                            </div>
                                        </div>
                                        <div class="comment-content-section">
                                            <p class="comment-content-text" [innerHTML]="comment.description"></p>

                                            <div class="comment-actions-section" *ngIf="!isReadOnly">
                                                <span class="comment-action-link" (click)="commentsOperation(comment, 'Edit', commentIndex)">Edit</span>
                                                <!-- <span class="comment-action-link" (click)="deleteComment(comment, commentIndex)">Delete</span> -->
                                                <span class="comment-action-link" (click)="removeComment(comment, commentIndex)">Delete</span>
                                            </div>
                                        </div>
                                    </div>
                                    <ng-container *ngIf="show_comments_operation_section == commentIndex">
                                        <ng-container *ngTemplateOutlet="commentsFieldsSection;"></ng-container>
                                        <!-- <div class="each-comment-section">
                                            <ng-container *ngTemplateOutlet="commentsSection;"></ng-container>
                                            <div class="page-modal-footer-section">
                                                <button class="page-modal-primary-button" (click)="saveComment()">Save</button>
                                                <button class="page-modal-secondary-button" (click)="resetCommentsData()">Cancel</button>
                                            </div>
                                        </div> -->
                                    </ng-container>
                                </ng-container>

                                <!-- <ng-container>
                                    <div class="each-comment-section" *ngIf="comment_operation_type == '' && !isReadOnly">
                                        <button class="add-activity-action-primary" style="margin-left: 0;" (click)="commentsOperation(comment_data, 'Add', null)">Add Comment</button>
                                    </div>
                                    <ng-container *ngIf="show_comments_operation_section == null">
                                        <div class="each-comment-section">
                                            <ng-container *ngTemplateOutlet="commentsSection;"></ng-container>
                                            <div class="page-modal-footer-section">
                                                <button class="page-modal-primary-button" (click)="saveComment()">Save</button>
                                                <button class="page-modal-secondary-button" (click)="resetCommentsData()">Cancel</button>
                                            </div>
                                        </div>
                                    </ng-container>
                                </ng-container> -->

                            </ng-container>

                            <ng-container *ngIf="activity_tab_selected == 'Attachments Old Version'">
                                <table class="activity-inner-table">
                                    <thead>
                                        <tr>
                                            <th *ngIf="!isReadOnly">Actions</th>
                                            <th>Attachment Name</th>
                                            <th>Comments</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <ng-container *ngFor="let attachment of activity_data.attachments; let attachmentIndex = index;">
                                            <tr *ngIf="attachment_operation_index != attachmentIndex">
                                                <td *ngIf="!isReadOnly">
                                                    <!-- <img src="assets/upload-attachment.png" class="each-attachment-icon" (click)="openAttachmentOperation(attachment, 'Edit', attachmentIndex)" />
                                                    <img src="assets/download-attachment.png" class="each-attachment-icon" (click)="downloadAttachment(attachment)" />
                                                    <img src="assets/delete-activity.png" class="each-attachment-icon" (click)="removeAttachment(attachment, attachmentIndex)" /> -->

                                                    <img src="assets/upload-icon-blue.png" [matTooltip]="'Upload Atttachmentt'" class="each-attachment-icon" (click)="openAttachmentOperation(attachment, 'Edit', attachmentIndex)" />
                                                    <img src="assets/download-icon-blue.png" [matTooltip]="'Download Atttachmentt'" class="each-attachment-icon" (click)="downloadAttachment(attachment)" />
                                                    <!-- Remove Delete <img src="assets/delete-icon.png" [matTooltip]="'Delete Atttachmentt'" class="each-attachment-icon" (click)="removeAttachment(attachment, attachmentIndex)" /> -->
                                                </td>
                                                <td>
                                                    <p>{{attachment.attachment_filename}}</p>
                                                </td>
                                                <td>
                                                    <p [innerHTML]="attachment.comments"></p>
                                                </td>
                                            </tr>
                                            <tr *ngIf="attachment_operation_index == attachmentIndex">
                                                <td colspan="3">
                                                    <div class="each-comment-section">
                                                        <ng-container *ngTemplateOutlet="attachmentsSection;"></ng-container>
                                                        <div class="page-modal-footer-section">
                                                            <button class="page-modal-primary-button" (click)="saveAttachment()">Save</button>
                                                            <button class="page-modal-secondary-button" (click)="resetAttachmentData()">Cancel</button>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </ng-container>
                                        <tr class="sub-tasks-row" *ngIf="!isReadOnly">
                                            <td colspan="3">
                                                <button class="add-activity-action-primary" *ngIf="attachment_operation_index != null" (click)="openAttachmentOperation(attachment_data, 'Add', null)">Add Attachment</button>
                
                                                <div class="each-comment-section" *ngIf="attachment_operation_index == null">
                                                    <ng-container *ngTemplateOutlet="attachmentsSection;"></ng-container>
                                                    <div class="page-modal-footer-section">
                                                        <button class="page-modal-primary-button" (click)="saveAttachment()">Save</button>
                                                        <button class="page-modal-secondary-button" (click)="resetAttachmentData()">Cancel</button>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </ng-container>

                            <ng-container *ngIf="activity_tab_selected == 'Attachments'">
                                <ng-container>
                                    <table class="attachments-table">
                                        <thead>
                                            <tr>
                                                <th *ngIf="!isReadOnly">Actions</th>
                                                <th>Attachment Name</th>
                                                <th>Comments</th>
                                            </tr>
                                        </thead>
                                        <tbody *ngIf="activity_data.attachments.length > 0">
                                            <ng-container *ngFor="let attachment of activity_data.attachments; let attachmentIndex = index;">
                                                <tr *ngIf="attachment_operation_index != attachmentIndex">
                                                    <td *ngIf="!isReadOnly">
                                                        <img src="assets/attachment-edit.png" [matTooltip]="'Upload Atttachmentt'" class="each-attachment-icon" (click)="openAttachmentOperation(attachment, 'Edit', attachmentIndex)" />
                                                        <img src="assets/attachment-download.png" [matTooltip]="'Download Atttachmentt'" class="each-attachment-icon" (click)="downloadAttachment(attachment)" />
                                                        <!-- Remove Delete <img src="assets/attachment-delete.png" [matTooltip]="'Delete Atttachmentt'" class="each-attachment-icon" (click)="removeAttachment(attachment, attachmentIndex)" /> -->
                                                    </td>
                                                    <td>
                                                        <p>{{attachment.attachment_filename}}</p>
                                                    </td>
                                                    <td>
                                                        <p [innerHTML]="attachment.comments"></p>
                                                    </td>
                                                </tr>
                                                <tr *ngIf="attachment_operation_index == attachmentIndex">
                                                    <td colspan="3">
                                                        <ng-container *ngTemplateOutlet="attachmentsFieldsSection;"></ng-container>
                                                    </td>
                                                </tr>
                                            </ng-container>
                                        </tbody>
                                        <!-- <tbody *ngIf="activity_data.attachments.length == 0">
                                            <tr>
                                                <td colspan="3">
                                                    <div style="text-align: center">
                                                        <span>No Attachments Found</span>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody> -->
                                    </table>
                                </ng-container>
                                <ng-container *ngIf="attachment_operation_index == null">
                                    <ng-container *ngTemplateOutlet="attachmentsFieldsSection;"></ng-container>
                                </ng-container>
                                <div class="each-activity-details-button-section" *ngIf="attachment_operation_index != null && !isReadOnly">
                                    <button class="activity-more-action" (click)="openAttachmentOperation(attachment_data, 'Add', null)" style="margin-right: 0;">+ Add New Attachment</button>
                                </div>
                            </ng-container>






                            <!-- Closed Deal Start -->
                            <ng-container *ngIf="activity_tab_selected == 'Close Deal'">
                                <ng-container>
                                    <ng-container *ngTemplateOutlet="productConversionSection;"></ng-container>
                                    <div class="each-activity-details-action-section">
                                        <button class="page-modal-primary-button" (click)="addProduct()">Save</button>
                                        <!-- <button class="page-modal-secondary-button" (click)="resetCloseDealData()">Cancel</button> -->
                                        <button class="page-modal-secondary-button" (click)="hideCloseDealView()">Cancel</button>
                                    </div>
                                </ng-container>
                            </ng-container>

                            <!-- <ng-container *ngIf="activity_tab_selected == 'Close Deal'">
                                <ng-container *ngTemplateOutlet="productConversionSection;"></ng-container>
                                <div class="page-modal-footer-section">
                                    <button class="page-modal-primary-button" (click)="addProduct()">Save</button>
                                    <button class="page-modal-secondary-button" (click)="resetCloseDealData()">Cancel</button>
                                </div>
                            </ng-container> -->

                            <!-- Closed Deal End -->


                            <ng-container *ngIf="activity_tab_selected == 'Change Outcome'">
                                <ng-container>
                                    <ng-container *ngTemplateOutlet="outcomeConversionSection;"></ng-container>
                                    <div class="each-activity-details-action-section">
                                        <button class="page-modal-primary-button" (click)="addOutcome()">Save</button>
                                        <!-- <button class="page-modal-secondary-button" (click)="resetCloseDealData()">Cancel</button> -->
                                        <button class="page-modal-secondary-button" (click)="hideChangeOutcomeView()">Cancel</button>
                                    </div>
                                </ng-container>
                            </ng-container>

                            <!-- <ng-container *ngIf="activity_tab_selected == 'Change Outcome'">
                                <ng-container *ngTemplateOutlet="outcomeConversionSection;"></ng-container>
                                <div class="page-modal-footer-section">
                                    <button class="page-modal-primary-button" (click)="addOutcome()">Save</button>
                                    <button class="page-modal-secondary-button" (click)="resetCloseDealData()">Cancel</button>
                                </div>
                            </ng-container> -->

                            <ng-container *ngIf="activity_tab_selected == 'History'">
                                <table class="activity-inner-table">
                                    <thead>
                                        <tr>
                                            <th>Activity Name</th>
                                            <th>Scheduled Date</th>
                                            <th>Status</th>
                                            <th>Activity Type</th>
                                        </tr>
                                    </thead>
                                    <tbody *ngIf="activity_data.past_activities.length > 0">
                                        <tr *ngFor="let past_activity of activity_data.past_activities">
                                            <td>
                                                <p class="sub-activity-name">{{past_activity.name}}</p>
                                            </td>
                                            <td>
                                                {{past_activity.scheduled_date | date: 'dd MMM yyyy'}}
                                            </td>
                                            <td>
                                                <span class="activity-table-tag" [ngClass]="{'pending-status-tag': past_activity.status_name == 'Pending', 'completed-status-tag': past_activity.status_name == 'Completed', 'in-progress-status-tag': past_activity.status_name == 'In Progress', 'not-required-status-tag': past_activity.status_name == 'Not Required', 'cancelled-status-tag': past_activity.status_name == 'Cancelled'}">{{past_activity.status_name}}</span>
                                            </td>
                                            <td>
                                                <span *ngIf="(past_activity.activity_type != 1) && (past_activity.activity_type != 4) && (past_activity.activity_type != 5)" class="activity-table-tag manual-task-tag">Manual</span>
                                                <span *ngIf="(past_activity.activity_type == 1) || (past_activity.activity_type == 4) || (past_activity.activity_type == 5)"class="activity-table-tag automated-task-tag">Automated</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tbody *ngIf="activity_data.past_activities.length == 0">
                                        <tr>
                                            <td colspan="4">
                                                <div style="text-align: center">
                                                    <span>No History Found</span>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </ng-container>

                            <ng-container *ngIf="activity_tab_selected == 'Campaign History'">
                                <table class="activity-inner-table">
                                    <thead>
                                        <tr>
                                            <th>Campaign Date</th>
                                            <th>Campaign Channel</th>
                                            <th>Content</th>
                                        </tr>
                                    </thead>
                                    <tbody *ngIf="activity_data.campaign_history.length > 0">
                                        <tr *ngFor="let campaign of activity_data.campaign_history">
                                            <td>
                                                {{campaign.campaign_date | date: 'dd MMM yyyy'}}
                                            </td>
                                            <td>
                                                <span class="activity-table-tag" [ngClass]="{'pending-status-tag': campaign.campaign_channel == 'Email Campaign', 'completed-status-tag': campaign.campaign_channel == 'Portal Campaign', 'in-progress-status-tag': campaign.campaign_channel == 'Message Campaign', 'not-required-status-tag': campaign.campaign_channel == 'Social Media Campaign'}">{{campaign.campaign_channel}}</span>
                                            </td>
                                            <td>
                                                <p class="sub-activity-name" [innerHTML]="campaign.campaign_content"></p>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tbody *ngIf="activity_data.campaign_history.length == 0">
                                        <tr>
                                            <td colspan="3">
                                                <div style="text-align: center">
                                                    <span>No Campaign History Found</span>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </ng-container>
                        </ng-container>

                    </div>
                    <div class="activity-action-section">
                        <div class="activity-action-input-section" *ngIf="activity_data.id != null &&  user_role != 'Advisor Manager'">
                            <span class="activity-action-input-label">Campaign</span>
                            <ng-container *ngIf="activity_data.email_campaign || activity_data.portal_campaign || activity_data.message_campaign || activity_data.social_media_campaign">
                                <!-- <img src="assets/email-campaign.png" [matTooltip]="'Email Notification'" class="campaign-icon" *ngIf="activity_data.email_campaign" /> -->
                                <img src="assets/email-campaign.png" [matTooltip]="'Email Notification'" class="campaign-icon" (click)="openEmail(activity_data)" />
                                <img src="assets/portal-campaign.png" [matTooltip]="'Portal Notification'" class="campaign-icon" *ngIf="activity_data.portal_campaign" (click)="openNotificationModal('Portal Campaign', activity_data.portal_notification_content)" />
                                <img src="assets/message-campaign.png" [matTooltip]="'Message Notification'" class="campaign-icon" *ngIf="activity_data.message_campaign" (click)="openNotificationModal('Message Campaign', activity_data.text_message_content)" />
                                <img src="assets/social-media-campaign.png" [matTooltip]="'Social Media Notification'" class="campaign-icon" *ngIf="activity_data.social_media_campaign" />
                            </ng-container>
                            <ng-container *ngIf="!activity_data.email_campaign && !activity_data.portal_campaign && !activity_data.message_campaign && !activity_data.social_media_campaign">
                                <span class="activity-table-tag manual-task-tag">None</span>
                            </ng-container>
                        </div>
                        <div class="activity-action-input-section">
                            <span class="activity-action-input-label">Status</span>
                            <div style="width: 50%;">
                                <mat-select class="activity-action-input" [(ngModel)]="activity_data.status" (selectionChange)="saveActivityDirectActions('status', activity_data.status, 'text')" [disabled]="isReadOnly"
                                [ngClass]="{'input-error-bg': activity_status_error}"> 
                                    <!-- <mat-option [value]="''">None</mat-option>  -->
                                    <mat-option *ngFor="let status of status_list" [value]="status.id">{{status.name}}</mat-option>
                                </mat-select>
                                <p class="input-error" *ngIf="activity_status_error">Status is required.</p>
                            </div>
                        </div>
                        <ng-container *ngIf="user_role == 'Advisor' || user_role == 'AFA' || user_role == 'Relationship Manager'">
                            <div class="activity-action-input-section">
                                <span class="activity-action-input-label">Assignee</span>
                                <div style="width: 50%;">
                                    <mat-select class="activity-action-input" [(ngModel)]="activity_data.afa_id" (selectionChange)="saveActivityDirectActions('afa_id', activity_data.afa_id, 'text')" [disabled]="isReadOnly" [ngClass]="{'input-error-bg': activity_assignee_error}"> 
                                        <mat-option [value]="''">Self</mat-option> 
                                        <mat-option *ngFor="let afa of afa_list" [value]="afa.id">{{ afa.first_name }} {{ afa.last_name }}</mat-option>
                                    </mat-select>
                                    <p class="input-error" *ngIf="activity_assignee_error">Assignee is required.</p>
                                </div>
                            </div>
                        </ng-container>
                        <div class="activity-action-input-section">
                            <span class="activity-action-input-label">Scheduled Date</span>
                            <div style="width: 50%;">
                                <input
                                    type="text"
                                    class="activity-action-input"
                                    bsDatepicker
                                    placement="left"
                                    [(ngModel)]="activity_data.scheduled_date"
                                    [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
                                    (ngModelChange)="saveActivityDirectActions('scheduled_date', activity_data.scheduled_date, 'date')"
                                    [disabled]="isReadOnly"
                                    [ngClass]="{'input-error-bg': activity_schedule_date_error}"
                                />
                                <p class="input-error" *ngIf="activity_schedule_date_error">Scheduled Date is required.</p>
                            </div>
                        </div>
                        <div class="activity-action-input-section">
                            <span class="activity-action-input-label">Actual Date</span>
                            <div style="width: 50%;">
                                <input
                                    type="text"
                                    class="activity-action-input"
                                    bsDatepicker
                                    placement="left"
                                    [(ngModel)]="activity_data.actual_date"
                                    [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
                                    (ngModelChange)="saveActivityDirectActions('actual_date', activity_data.actual_date, 'date')"
                                    [disabled]="isReadOnly"
                                />
                                <!-- [minDate]="activity_data.scheduled_date" -->
                            </div>
                        </div>
                        <div class="activity-action-input-section">
                            <span class="activity-action-input-label">Communication Channel</span>
                            <div style="width: 50%;">
                                <mat-select class="activity-action-input" [(ngModel)]="activity_data.communication_type" (selectionChange)="saveActivityDirectActions('communication_type', activity_data.communication_type, 'text')" [disabled]="isReadOnly" [ngClass]="{'input-error-bg': activity_channel_error}"> 
                                    <!-- <mat-option [value]="''">None</mat-option>  -->
                                    <mat-option *ngFor="let communication of communication_type_list" [value]="communication.id">{{ communication.name }}</mat-option>
                                </mat-select>
                                <p class="input-error" *ngIf="activity_channel_error">Communication Channel is required.</p>
                                <div>
                                    <ng-container *ngIf="activity_data.communication_type == 10 && user_details.Zoom_connected && activity_data.id != null">
                                        <span class="activity-link" (click)="openScheduleMeetingModal()">Schedule a meeting</span>
                                    </ng-container>
                                    <!-- <span class="activity-link" (click)="openScheduleMeetingModal()">Schedule a meeting</span> -->
                                </div>
                            </div>
                        </div>
                        <div>
                            <button class="page-modal-primary-button" (click)="saveActivityData()">Save Activity</button>
                            <button class="page-modal-secondary-button" (click)="close()">Cancel</button>
                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="!activity_data_loaded">
                <app-loader [loading_text]="'Loading Activity Data'"></app-loader>
            </ng-container>
        </div>
    </div>
</div>





<ng-template #activitiesDeleteModal>
    <div class="modal-section">
        <div class="modal-heading-section client-view-heading-section">
            <span class="modal-heading">Delete Activity</span>
            <span class="client-modal-icon" (click)="closeDeleteActivityModal()">&times;</span>
        </div>
        <div class="modal-content-section">
            <p class="page-modal-delete-description">Are you sure you want to delete?</p>
        </div>
        <div class="modal-footer-section">
            <button class="page-modal-primary-button" (click)="deleteActivity()">Yes</button>
            <button class="page-modal-secondary-button" (click)="closeDeleteActivityModal()">No</button>
        </div>
    </div>
</ng-template>



<ng-template #automatedActivitiesOperationModal>
    <div class="modal-section">
        <div class="modal-heading-section client-view-heading-section">
            <span class="modal-heading">Activity Operation</span>
            <span class="client-modal-icon" (click)="closeAutomatedActivityOperationModal()">&times;</span>
        </div>
        <div class="modal-content-section">
            <p class="page-modal-delete-description">
                Do you want to 
                <span *ngIf="activity_data.activity_paused">resume</span> 
                <span *ngIf="!activity_data.activity_paused">stop</span> the activity
            </p>
        </div>
        <div class="modal-footer-section">
            <button class="page-modal-primary-button" (click)="automatedActivityOperation()">Yes</button>
            <button class="page-modal-secondary-button" (click)="closeAutomatedActivityOperationModal()">No</button>
        </div>
    </div>
</ng-template>

<ng-template #activityEmailPreviewModal>
    <div class="page-modal-section">
        <div class="page-modal-heading-section">
            <span>{{ activity_email_data.template_name }}</span>
            <span class="page-modal-close-icon" (click)="closeActivityEmailPreviewModal()">&times;</span>
        </div>
        <div class="page-modal-content-section" *ngIf="activity_email_data_loaded">
            <div class="page-modal-input-section">
                <p class="page-modal-input-label">Subject: {{ activity_email_data.subject }}</p>
            </div>
            <div class="page-modal-input-section">
                <p class="page-modal-input-label">Email Body:</p>
                <p class="page-modal-input-label" [innerHTML]="getHTML(activity_email_data.email_body)">{{ activity_email_data.template_name }}</p>
            </div>
            <div class="page-modal-input-section" *ngIf=" activity_email_data.greetings_image != '' && activity_email_data.greetings_image != null ">
                <button class="page-modal-primary-button" (click)="download(activity_email_data.greetings_image)" >Download Attachment</button>
            </div>
        </div>
        <div class="page-modal-content-section" *ngIf="!activity_email_data_loaded">
            <app-loader [loading_text]="'Loading'"></app-loader>
        </div>
        <div class="page-modal-footer-section">
            <button class="page-modal-secondary-button" (click)="closeActivityEmailPreviewModal()">Cancel</button>
        </div>
    </div>
</ng-template>

<ng-template #attachmentsFieldsSection>
    <div class="comments-fields-section">
        <div class="comment-details-section">
            <div class="attachment-details-input-section">
                <div class="attachment-upload-section">
                    <input type="file" #file_upload style="display: none;" (change)="uploadAttachment($event)" />
                    <button class="page-modal-primary-button" (click)="file_upload.click()">Upload Attachment</button>
                    <p class="attachment-name">{{attachment_data.attachment_filename}}</p>
                    <p class="input-error" *ngIf="attachment_data_errors.attachment_filename">Attachment is Required.</p>
                </div>
                <diiv class="attachment-input-section">
                    <app-textarea-tagging [value]="attachment_data.comments" [users]="tagging_users_list" [placeholder]="'Attachment Comments...'" (valueChanged)="attachment_data.comments = $event"></app-textarea-tagging>
                    <p class="input-error" *ngIf="attachment_data_errors.comments">Comments is Required.</p>
                </diiv>
            </div>
            <div class="activity-editable-action-section" *ngIf="!save_attachment_loader">
                <img src="assets/activity-save.png" class="activity-editable-action-icon" (click)="saveAttachment()" />
                <img src="assets/activity-cancel.png" class="activity-editable-action-icon" (click)="resetAttachmentData()" />
            </div>
            <div class="activity-editable-action-section" *ngIf="save_attachment_loader">
                <img src="assets/activity-save.png" class="activity-editable-action-icon" />
                <img src="assets/activity-cancel.png" class="activity-editable-action-icon" />
            </div>
        </div>
    </div>
</ng-template>

<ng-template #commentsFieldsSection>
    <div class="comments-fields-section">
        <div class="comment-details-section">
            <div class="comment-author-circle">
                <span>{{user_details.first_name[0]}}</span>
            </div>
            <div class="comment-details-input-section">
                <div class="comment-date-input-section">
                    <input
                        type="text"
                        class="capture-response-input"
                        bsDatepicker
                        placement="right"
                        [(ngModel)]="comment_data.comment_date"
                        [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
                    />
                    <p class="input-error" *ngIf="comment_data_errors.comment_date">Date is Required.</p>
                </div>
                <diiv class="comment-input-section">
                    <app-textarea-tagging [value]="comment_data.description" [users]="tagging_users_list" [placeholder]="'Comment ...'" (valueChanged)="comment_data.description = $event"></app-textarea-tagging>
                    <p class="input-error" *ngIf="comment_data_errors.description">Comments is Required.</p>
                </diiv>
            </div>
            <div class="activity-editable-action-section" *ngIf="!save_comment_loader">
                <img src="assets/activity-save.png" class="activity-editable-action-icon" (click)="saveComment()" />
                <img src="assets/activity-cancel.png" class="activity-editable-action-icon" (click)="resetCommentsData()" />
            </div>
            <div class="activity-editable-action-section" *ngIf="save_comment_loader">
                <img src="assets/activity-save.png" class="activity-editable-action-icon" />
                <img src="assets/activity-cancel.png" class="activity-editable-action-icon" />
            </div>
        </div>
    </div>
</ng-template>


<!-- Comments Inputs Section -->
<ng-template #commentsSection>
    <div class="capture-response-section">
        <div class="capture-response-input-section" style="width: 50%;">
            <p class="capture-response-input-label">Date</p>
            <input
                type="text"
                class="capture-response-input"
                bsDatepicker
                placement="right"
                [(ngModel)]="comment_data.comment_date"
                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
            />
            <p class="input-error" *ngIf="comment_data_errors.comment_date">Date is Required.</p>
        </div>
        <div>
            <div class="capture-response-input-section" style="width: 100%;">
                <p class="capture-response-input-label">Comments</p>
                <app-textarea-tagging [value]="comment_data.description" [users]="tagging_users_list" [placeholder]="'Comment ...'" (valueChanged)="comment_data.description = $event"></app-textarea-tagging>
                <p class="input-error" *ngIf="comment_data_errors.description">Comments is Required.</p>
            </div>
        </div>
    </div>
</ng-template>

<!-- Attachments Inputs Section -->
<ng-template #attachmentsSection>
    <div class="capture-response-section">
        <div>
            <div class="capture-response-input-section" style="width: 50%;">
                <!-- <p class="capture-response-input-label">Upload Attachment</p> -->
                <input type="file" #file_upload style="display: none;" (change)="uploadAttachment($event)" />
                <button class="page-modal-primary-button" (click)="file_upload.click()">Upload Attachment</button>
                <span>{{attachment_data.attachment_filename}}</span>
                <p class="input-error" *ngIf="attachment_data_errors.attachment_filename">Attachment is Required.</p>
            </div>
        </div>
        <div>
            <div class="capture-response-input-section" style="width: 100%;">
                <p class="capture-response-input-label">Comments</p>
                <app-textarea-tagging [value]="attachment_data.comments" [users]="tagging_users_list" [placeholder]="'Attachment Comments ...'" (valueChanged)="attachment_data.comments = $event"></app-textarea-tagging>
                <p class="input-error" *ngIf="attachment_data_errors.comments">Comments is Required.</p>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #attachmentDeleteModal>
    <div class="modal-section">
        <div class="modal-heading-section client-view-heading-section">
            <span class="modal-heading">Delete Attachment Details</span>
            <span class="client-modal-icon" (click)="closeDeleteAttachmentModal()">&times;</span>
        </div>
        <div class="modal-content-section">
            <p class="page-modal-delete-description">Are you sure you want to delete?</p>
        </div>
        <div class="modal-footer-section">
            <button class="page-modal-primary-button" (click)="deleteAttachment()">Yes</button>
            <button class="page-modal-secondary-button" (click)="closeDeleteAttachmentModal()">No</button>
        </div>
    </div>
</ng-template>

<ng-template #commentDeleteModal>
    <div class="modal-section">
        <div class="modal-heading-section client-view-heading-section">
            <span class="modal-heading">Delete Comment Details</span>
            <span class="client-modal-icon" (click)="closeDeleteAttachmentModal()">&times;</span>
        </div>
        <div class="modal-content-section">
            <p class="page-modal-delete-description">Are you sure you want to delete?</p>
        </div>
        <div class="modal-footer-section">
            <button class="page-modal-primary-button" (click)="deleteComment()">Yes</button>
            <button class="page-modal-secondary-button" (click)="closeDeleteCommentModal()">No</button>
        </div>
    </div>
</ng-template>










<!-- Conversion Status and Dropdown and its Products Starts -->
<ng-template #productConversionSection>
    <div class="capture-response-section">
        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Conversion Status *</p>
            <mat-select class="capture-response-input" [(ngModel)]="conversion_status_data.conversion_status" >
                <mat-option [value]="''">Select Conversion Status</mat-option>
                <mat-option *ngFor="let conversion_status of conversion_status_list" [value]="conversion_status.id" (click)=" conversion_status_data.conversion_status_name = conversion_status.name ">{{ conversion_status.name }}</mat-option>
            </mat-select>
            <p class="input-error" *ngIf="conversion_status_data_errors.conversion_status">Conversion Status is Required.</p>
        </div>
        <div>
            <div class="capture-response-input-section" style="width: 100%;">
                <p class="capture-response-input-label">Comments *</p>
                <app-textarea-tagging [value]="conversion_status_data.conversion_comments" [users]="tagging_users_list" [placeholder]="'Comments ...'" (valueChanged)="conversion_status_data.conversion_comments = $event"></app-textarea-tagging>
                <p class="input-error" *ngIf="conversion_status_data_errors.conversion_comments">Comments is Required.</p>
            </div>
        </div>

        <ng-container *ngIf="user_details.role.business_area[0] == '5'">
            <ng-container *ngIf="conversion_status_data.conversion_status == 1">
                <ng-container *ngTemplateOutlet="productOperationSection;"></ng-container>
            </ng-container>
        </ng-container>

        <ng-container *ngIf="user_details.role.business_area[0] == '6'">
            <ng-container *ngIf="conversion_status_data.conversion_status == 1">
                <ng-container *ngTemplateOutlet="depositproductOperationSection;"></ng-container>
            </ng-container>
        </ng-container>
    
    </div>
</ng-template>
<!-- Conversion Status and Dropdown and its Products Ends -->



<ng-template #productOperationSection>
    <div style="display: flex; flex-direction: row; flex-wrap: wrap;">
        <div class="capture-response-input-section">
            <p class="capture-response-input-label" *ngIf="user_role != 'Relationship Manager'">Policy Number *</p>
            <p class="capture-response-input-label" *ngIf="user_role == 'Relationship Manager'">Deposit Number *</p>
            <input type="text" class="capture-response-input" [(ngModel)]="product_data.policy_number" />
            <p class="input-error" *ngIf="product_data_errors.policy_number">
                <span *ngIf="user_role != 'Relationship Manager'">Policy Number</span>
                <span *ngIf="user_role == 'Relationship Manager'">Deposit Number</span>
                is Required.
            </p>
        </div>
        <div class="capture-response-input-section">
            <p class="capture-response-input-label">AUM *</p>
            <input type="text" class="capture-response-input" [(ngModel)]="product_data.aum" (keypress)="numberOnly($event)" />
            <p class="input-error" *ngIf="product_data_errors.aum">AUM is Required.</p>
        </div>
        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Product *</p>
            <mat-select class="capture-response-input" [(ngModel)]="product_data.product">
                <mat-option [value]="''">Select Product</mat-option>
                <mat-option *ngFor="let product of product_list" [value]="product.id" (click)="getProductType(product_data.product)" >{{ product.name }}</mat-option>
            </mat-select>
            <p class="input-error" *ngIf="product_data_errors.product">Product is Required.</p>
        </div>
        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Activated Date *</p>
            <input
                type="text"
                class="capture-response-input"
                bsDatepicker
                placement="right"
                [(ngModel)]="product_data.start_date"
                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
            />
            <!-- [disabled]="product_data.start_date == '' || product_data.start_date == null" -->
            <p class="input-error" *ngIf="product_data_errors.start_date">Activated Date is Required.</p>
        </div>
        <div class="capture-response-input-section" *ngIf="getProductType(product_data.product)">
            <p class="capture-response-input-label">Valid Until *</p>
            <input
                type="text"
                class="capture-response-input"
                bsDatepicker
                placement="right"
                [(ngModel)]="product_data.close_date"
                [minDate]="product_data.start_date"
                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
            />
            <p class="input-error" *ngIf="product_data_errors.close_date">Valid Until is Required.</p>
        </div>
        <div class="capture-response-input-section" *ngIf="user_role == 'Relationship Manager'">
            <p class="capture-response-input-label">Purpose *</p>
            <mat-select class="capture-response-input" [(ngModel)]="product_data.deposit_purpose">
                <mat-option [value]="''">Select Purpose</mat-option>
                <mat-option [value]="'Emergency Fund'">Emergency Fund</mat-option>
                <mat-option [value]="'Short-Term Goals'">Short-Term Goals</mat-option>
                <mat-option [value]="'Long-Term Savings'">Long-Term Savings</mat-option>
                <mat-option [value]="'Education Expenses'">Education Expenses</mat-option>
                <mat-option [value]="'Retirement Savings'">Retirement Savings</mat-option>
                <mat-option [value]="'Building Wealth'">Building Wealth</mat-option>
                <mat-option [value]="'Income Generation'">Income Generation</mat-option>
                <mat-option [value]="'Estate Planning'">Estate Planning</mat-option>
                <mat-option [value]="'Tax Payments'">Tax Payments</mat-option>
                <mat-option [value]="'Business Operations'">Business Operations</mat-option>
            </mat-select>
            <p class="input-error" *ngIf="product_data_errors.deposit_purpose">Purpose is Required.</p>
        </div>
        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Type *</p>
            <mat-select class="capture-response-input" [(ngModel)]="product_data.type">
                <mat-option [value]="''">Select Type</mat-option>
                <!-- <mat-option [value]="'New Acquisition'">New Acquisition</mat-option>
                <mat-option [value]="'Cross-Sell'">Cross-Sell</mat-option>
                <mat-option [value]="'Up-Sell'">Up-Sell</mat-option> -->
                <mat-option [value]="'New Acquisition'">New Acquisition</mat-option>
                <mat-option [value]="'Upside'">Upside</mat-option>
                <mat-option [value]="'Retention'">Retention</mat-option>
            </mat-select>
            <p class="input-error" *ngIf="product_data_errors.type">Type is Required.</p>
        </div>
        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Client Product Status *</p>
            <mat-select class="capture-response-input" [(ngModel)]="product_data.client_product_status">
                <mat-option [value]="''">Select Product Status</mat-option>
                <mat-option *ngFor="let status of client_product_status_list" [value]="status.id">{{status.name}}</mat-option>
            </mat-select>
            <p class="input-error" *ngIf="product_data_errors.client_product_status"> Client Product Status is Required.</p>
        </div>
    </div>
</ng-template>


<!-- deposit Product Operation Section Start -->
<ng-template #depositproductOperationSection>
    <div style="display: flex; flex-direction: row; flex-wrap: wrap;">

        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Product *</p>
            <mat-select class="capture-response-input" [(ngModel)]="depositProduct_data.product">
                <mat-option [value]="''">Select Product</mat-option>
                <mat-option *ngFor="let product of product_list" [value]="product.id" (click)="getProductType(depositProduct_data.product)" >{{ product.name }}</mat-option>
            </mat-select>
            <p class="input-error" *ngIf="depositProduct_data_errors.product">Product is Required.</p>
        </div>

        <div class="capture-response-input-section">
            <p class="capture-response-input-label" >Policy Number *</p>
            <input type="text" class="capture-response-input" [(ngModel)]="depositProduct_data.policy_number" />
            <p class="input-error" *ngIf="depositProduct_data_errors.policy_number">Policy Number is Required.</p>
        </div>

        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Amount *</p>
            <input type="text" class="capture-response-input" [(ngModel)]="depositProduct_data.aum" (input)="checkAmountValidation(depositProduct_data.product, depositProduct_data.aum)" (keypress)="numberOnly($event)" />
            <p class="input-error" *ngIf="depositProduct_data_errors.aum">Amount is Required.</p>
            <p class="input-error" *ngIf="min_amount_error">{{min_amount_error_text}}</p>
        </div>

        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Start Date *</p>
            <input
                type="text"
                class="capture-response-input"
                bsDatepicker
                placement="right"
                [(ngModel)]="depositProduct_data.start_date"
                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
            />
            <p class="input-error" *ngIf="depositProduct_data_errors.start_date">Activated Date is Required.</p>
        </div>


        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Valid Until *</p>
            <input
                type="text"
                class="capture-response-input"
                bsDatepicker
                placement="right"
                [(ngModel)]="depositProduct_data.close_date"
                [minDate]="depositProduct_data.start_date"
                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
            />
            <!-- [disabled]="depositProduct_data.start_date == '' || depositProduct_data.start_date == null" -->
            <p class="input-error" *ngIf="depositProduct_data_errors.close_date">Valid Until is Required.</p>
        </div>


        <!-- <div class="capture-response-input-section" *ngIf="user_role == 'Relationship Manager'">
            <p class="capture-response-input-label">Purpose *</p>
            <mat-select class="capture-response-input" [(ngModel)]="depositProduct_data.deposit_purpose">
                <mat-option [value]="''">Select Purpose</mat-option>
                <mat-option [value]="'Emergency Fund'">Emergency Fund</mat-option>
                <mat-option [value]="'Short-Term Goals'">Short-Term Goals</mat-option>
                <mat-option [value]="'Long-Term Savings'">Long-Term Savings</mat-option>
                <mat-option [value]="'Education Expenses'">Education Expenses</mat-option>
                <mat-option [value]="'Retirement Savings'">Retirement Savings</mat-option>
                <mat-option [value]="'Building Wealth'">Building Wealth</mat-option>
                <mat-option [value]="'Income Generation'">Income Generation</mat-option>
                <mat-option [value]="'Estate Planning'">Estate Planning</mat-option>
                <mat-option [value]="'Tax Payments'">Tax Payments</mat-option>
                <mat-option [value]="'Business Operations'">Business Operations</mat-option>
            </mat-select>
            <p class="input-error" *ngIf="depositProduct_data_errors.deposit_purpose">Purpose is Required.</p>
        </div> -->


        <!-- <div class="capture-response-input-section">
            <p class="capture-response-input-label" >Tenure (Months) *</p>
            <input type="text" class="capture-response-input" [(ngModel)]="depositProduct_data.tenure" />
            <p class="input-error" *ngIf="depositProduct_data_errors.tenure">
                <span>Tenure</span>
                is Required.
            </p>
        </div> -->

        <div class="capture-response-input-section">
            <p class="capture-response-input-label" >Interest Rate (%) *</p>
            <input type="text" class="capture-response-input" [(ngModel)]="depositProduct_data.interest_rate" (keypress)="validateMaxValue($event, 100)" />
            <p class="input-error" *ngIf="depositProduct_data_errors.interest_rate">Interest Rate (%) is Required.</p>
        </div>

        <div class="capture-response-input-section">
            <p class="capture-response-input-label" >Monthly Fees *</p>
            <input type="text" class="capture-response-input" [(ngModel)]="depositProduct_data.monthly_fees" />
            <p class="input-error" *ngIf="depositProduct_data_errors.monthly_fees">Monthly Fees is Required.</p>
        </div>


        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Type *</p>
            <mat-select class="capture-response-input" [(ngModel)]="depositProduct_data.type">
                <mat-option [value]="''">Select Type</mat-option>
                <!-- <mat-option [value]="'New Acquisition'">New Acquisition</mat-option>
                <mat-option [value]="'Cross-Sell'">Cross-Sell</mat-option>
                <mat-option [value]="'Up-Sell'">Up-Sell</mat-option> -->
                <mat-option [value]="'New Acquisition'">New Acquisition</mat-option>
                <mat-option [value]="'Upside'">Upside</mat-option>
                <mat-option [value]="'Retention'">Retention</mat-option>
            </mat-select>
            <p class="input-error" *ngIf="depositProduct_data_errors.type">Type is Required.</p>
        </div>



        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Client Product Status *</p>
            <mat-select class="capture-response-input" [(ngModel)]="depositProduct_data.client_product_status">
                <mat-option [value]="''">Select Product Status</mat-option>
                <mat-option *ngFor="let status of client_product_status_list" [value]="status.id">{{status.name}}</mat-option>
            </mat-select>
            <p class="input-error" *ngIf="depositProduct_data_errors.client_product_status"> Client Product Status is Required.</p>
        </div>
    </div>
</ng-template>
<!-- deposit Product Operation Section End -->



<ng-template #outcomeConversionSection>
    <div class="capture-response-section">
        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Outcome Status *</p>
            <mat-select class="capture-response-input" [(ngModel)]="outcome_data.attrition_status" >
                <mat-option [value]="''">Select Outcome Status</mat-option>
                <mat-option [value]="'Retained'">Retained</mat-option>
                <mat-option [value]="'Retained, Upside'">Retained, Upside</mat-option>
                <mat-option [value]="'Likely to Switch Advisor'">Likely to Switch Advisor</mat-option>
            </mat-select>
            <p class="input-error" *ngIf="outcome_data_errors.attrition_status">Outcome Status is Required.</p>
        </div>
        <ng-container *ngIf="outcome_data.attrition_status == 'Likely to Switch Advisor'">
            <div class="capture-response-input-section">
                <p class="capture-response-input-label">Reason *</p>
                <mat-select class="capture-response-input" [(ngModel)]="outcome_data.attrition_comments" >
                    <mat-option [value]="''">Select Reason</mat-option>
                    <mat-option *ngFor="let attrition_reason of attrition_reasons_list" [value]="attrition_reason.name">{{attrition_reason.name}}</mat-option>
                </mat-select>
                <p class="input-error" *ngIf="outcome_data_errors.attrition_comments">Reason is Required.</p>
            </div>
        </ng-container>
        <div *ngIf="outcome_data.attrition_status != 'Likely to Switch Advisor'">
            <div class="capture-response-input-section" style="width: 100%;">
                <p class="capture-response-input-label">Comments *</p>
                <app-textarea-tagging [value]="outcome_data.attrition_comments" [users]="tagging_users_list" [placeholder]="'Comments ...'" (valueChanged)="outcome_data.attrition_comments = $event"></app-textarea-tagging>
                <p class="input-error" *ngIf="outcome_data_errors.attrition_comments">Comments is Required.</p>
            </div>
        </div>

        <ng-container *ngIf="user_details.role.business_area[0] == '5'">
            <ng-container *ngIf="outcome_data.attrition_status == 'Retained, Upside'">
                <ng-container *ngTemplateOutlet="productOperationSection;"></ng-container>
            </ng-container>
        </ng-container>


        <ng-container *ngIf="user_details.role.business_area[0] == '6'">
            <ng-container *ngIf="outcome_data.attrition_status == 'Retained, Upside'">
                <ng-container *ngTemplateOutlet="depositproductOperationSection;"></ng-container>
            </ng-container>
        </ng-container>
    </div>
</ng-template>


<ng-template #notificationModal>
    <div class="page-modal-section">
        <div class="page-modal-heading-section">
            <span class="modal-heading">{{notification_data.campaign_channel}}</span>
            <span class="page-modal-close-icon" (click)="closeNotificationModal()">&times;</span>
        </div>
        <div class="page-modal-content-section">
            <div>
                <div class="capture-response-input-section" style="width: 100%; margin-right: 0;">
                    <p class="capture-response-input-label">Notification Content *</p>
                    <app-textarea-tagging [value]="notification_data.campaign_content" [users]="[]" [placeholder]="'Notification Content ...'" (valueChanged)="notification_data.campaign_content = $event"></app-textarea-tagging>
                    <p class="input-error" *ngIf="notification_data_errors.campaign_content">Notification Content is Required.</p>
                </div>
            </div>
        </div>
        <div class="page-modal-footer-section">
            <button class="page-modal-primary-button" (click)="sendNotification()">Send</button>
            <button class="page-modal-secondary-button" (click)="closeNotificationModal()">Cancel</button>
        </div>
    </div>
</ng-template>

<ng-template #scheduleMeetingModal>
    <div class="page-modal-section">
        <div class="page-modal-heading-section">
            <span class="modal-heading">Schedule Meeting</span>
            <span class="page-modal-close-icon" (click)="closeScheduleMeetingModal()">&times;</span>
        </div>
        <div class="page-modal-content-section">
            <div>
                <div class="capture-response-input-section" style="width: 100%; margin-right: 0;">
                    <p class="capture-response-input-label">Topic *</p>
                    <input type="text" class="capture-response-input" [(ngModel)]="meeting_data.topic" />
                    <p class="input-error" *ngIf="meeting_data_errors.topic">Topic is Required.</p>
                </div>
            </div>
            <div>
                <div class="capture-response-input-section" style="width: 100%; margin-right: 0;">
                    <!-- <p class="capture-response-input-label">Description</p> -->
                    <p class="capture-response-input-label">Meeting Notes *</p>
                    <app-textarea-tagging [value]="meeting_data.description" [users]="[]" [placeholder]="'Description ...'" (valueChanged)="meeting_data.description = $event"></app-textarea-tagging>
                    <p class="input-error" *ngIf="meeting_data_errors.description">Description is Required.</p>
                </div>
            </div>
            <div style="display: inline-block; vertical-align: top; width: calc(100% - 12px); margin-right: 12px;">
                <div class="capture-response-input-section" style="width: 100%; margin-right: 0;">
                    <!-- <p class="capture-response-input-label">Attendees</p> -->
                    <p class="capture-response-input-label">Invite Others(Optional)</p>
                    <mat-chip-list #attendeesEmailList>
                        <mat-chip *ngFor="let email of meeting_data.attendees" [removable]="true" (removed)="removeAtteendeeEmail(email)">
                            {{email}}
                            <mat-icon matChipRemove>cancel</mat-icon>
                        </mat-chip>
                        <div style="width: 100%;">
                            <input
                                class="capture-response-input"
                                placeholder="Attendee email..."
                                [matChipInputFor]="attendeesEmailList"
                                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                [matChipInputAddOnBlur]="true"
                                (matChipInputTokenEnd)="addAtteendeeEmail($event)"
                            />
                        </div>
                    </mat-chip-list>
                    <div *ngIf="attendees_error" class="input-error">Invalid email address</div>
                    <p class="input-error" *ngIf="meeting_data_errors.attendees">Attendees is Required.</p>
                </div>
            </div>
            <div style="display: inline-block; vertical-align: top; width: calc(50% - 12px); margin-right: 12px;">
                <div class="capture-response-input-section" style="width: 100%; margin-right: 0;">
                    <p class="capture-response-input-label">When *</p>
                    <input
                        type="text"
                        class="capture-response-input"
                        bsDatepicker
                        placement="right"
                        [(ngModel)]="meeting_data.when"
                        [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
                        (ngModelChange)="generateTimeSlots()"
                    />
                    <p class="input-error" *ngIf="meeting_data_errors.when">When is Required.</p>
                </div>
            </div>
            <div style="display: inline-block; vertical-align: top; width: calc(25% - 12px); margin-right: 12px;">
                <div class="capture-response-input-section" style="width: 100%; margin-right: 0;">
                    <p class="capture-response-input-label">Time *</p>
                    <mat-select class="capture-response-input" [(ngModel)]="meeting_data.time">
                        <mat-option [value]="''">Select Time</mat-option>
                        <mat-option *ngFor="let time_slot of time_slots" [value]="time_slot">{{time_slot}}</mat-option>
                    </mat-select>   
                    <p class="input-error" *ngIf="meeting_data_errors.time">Time is Required.</p>
                </div>
            </div>
            <div style="display: inline-block; vertical-align: top; width: 25%;">
                <div class="capture-response-input-section" style="width: 100%; margin-right: 0;">
                    <p class="capture-response-input-label">Duration *</p>
                    <mat-select class="capture-response-input" [(ngModel)]="meeting_data.duration">
                        <mat-option [value]="''">Select Duration</mat-option>
                        <mat-option *ngFor="let duration_slot of duration_slots" [value]="duration_slot.value">{{duration_slot.name}}</mat-option>
                    </mat-select>   
                    <p class="input-error" *ngIf="meeting_data_errors.duration">Duration is Required.</p>
                </div>
            </div>
            <div>
                <div class="capture-response-input-section" style="width: 100%; margin-right: 0;">
                    <p class="capture-response-input-label">Timezone *</p>
                    <mat-select class="capture-response-input" [(ngModel)]="meeting_data.timezone">
                        <mat-option [value]="''">Select Timezone</mat-option>
                        <mat-option *ngFor="let timezone of timezone_list" [value]="timezone.value">{{timezone.name}}</mat-option>
                    </mat-select>   
                    <p class="input-error" *ngIf="meeting_data_errors.timezone">Timezone is Required.</p>
                </div>
            </div>
            <div>
                <div class="capture-response-input-section" style="width: 100%; margin-right: 0;">
                    <!-- <p class="capture-response-input-label">Attachments</p> -->
                    <p class="capture-response-input-label">Attachments(Optional)</p>
                    <input type="file" multiple style="display: none;" #meetingAtachmentFile (change)="uploadAtatchmentFile($event)" />
                    <!-- <input type="file" style="display: none;" #meetingAtachmentFile (change)="uploadAtatchmentFile($event)" /> -->
                    <button class="page-modal-primary-button" (click)="meetingAtachmentFile.click()">Upload</button>
                    <p class="input-error" *ngIf="meeting_data_errors.attachments">Attachments should be minimum one.</p>
                    <div class="each-proposal-document-section" *ngFor="let file of meeting_data.attachments; let index = index">
                        <span>{{file.name}}</span>
                        <span class="each-proposal-document-remove-icon" (click)="deleteAttachmentFile(index)">&times;</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="page-modal-footer-section">
            <button class="page-modal-primary-button" (click)="scheduleMeeting()">Send</button>
            <button class="page-modal-secondary-button" (click)="closeScheduleMeetingModal()">Cancel</button>
        </div>
    </div>
</ng-template>